<p-toast></p-toast>

<div class="card header-container mb-2">
    <div class="p-fluid p-formgrid grid justify-content-around">
        <div class="field col-12 md:col-4">
            <div class="flex flex-column align-items-center justify-content-center mb-2">
                <label style="font-weight: bold; color: 'rgb(168, 32, 32)'">{{ "SELECT_SUBSIDY_LOT" | translate
                    }}</label>
            </div>
            <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="dropDownList" label="zz"
                placeholder="{{'SELECT_APPLICATION_TYPE'| translate}}" optionLabel="type"
                [(ngModel)]="applicationSelected" [disabled]="">
            </p-dropdown>
        </div>
    </div>

    <!-- <div class="card grid">
            <div class="col-12 md:col-6">
                <div class="flex  justify-content-between flex-wrap">
                    <div class="flex flex-column align-items-center justify-content-center col-12 md:col-6">
                        <h6>{{'SELECT_SUBSIDY_LOT'| translate}}</h6>
                        <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="dropDownList" label="zz"
                            placeholder="{{'SELECT_APPLICATION_TYPE'| translate}}" optionLabel="type"
                            [(ngModel)]="applicationSelected" [disabled]="">
                        </p-dropdown>
                    </div>
                </div>

            </div>
        </div> -->

</div>

<router-outlet></router-outlet>